import React from "react";
import { Link } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface SimpleLegalLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

// centered single-column text page for simple legal documents
export function SimpleLegalLayout({
  title,
  subtitle,
  children,
}: SimpleLegalLayoutProps) {
  return (
    <div className="min-h-screen px-4 sm:px-6 lg:px-8 py-12">
      <div className="mx-auto max-w-2xl">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-primary"
        >
          <ArrowLeftIcon className="h-4 w-4" />
          back
        </Link>
        <header className="mb-8 mt-4">
          <h1 className="text-2xl font-bold text-foreground">{title}</h1>
          {subtitle && (
            <p className="mt-2 text-muted-foreground">{subtitle}</p>
          )}
        </header>
        <div className="space-y-8">{children}</div>
        <div className="h-16" />
      </div>
    </div>
  );
}

export function SimpleLegalSection({
  title,
  children,
  className,
}: {
  title?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section className={cn("space-y-3", className)}>
      {title && (
        <h2 className="text-xl font-bold text-foreground">{title}</h2>
      )}
      <div className="text-sm leading-relaxed text-foreground/90 space-y-3">
        {children}
      </div>
    </section>
  );
}
